<template>
  <v-container fluid>
    <v-card>
      <v-tabs
        v-model="tab"
        background-color="transparent"
      >
        <v-tab
          v-for="item in items"
          :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <pcb-statement-container-view />
        </v-tab-item>

        <v-tab-item>
          <pcb-arrear-container-view />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    components: {
      PcbArrearContainerView: () => import('@/components/hris/payroll/pcb-two/PcbArrearContainerView'),
      PcbStatementContainerView: () => import('@/components/hris/payroll/pcb-two/PcbStatementContainerView'),
    },

    data () {
      return {
        tab: null,
        items: [
          'PCB Statement', 'PCB Arrear',
        ],
      }
    },
  }
</script>
